import reducers from './reducers/web';
import configureStoreWeb from './configure-store';

export default function configureStore() {
  return configureStoreWeb(reducers);
}
